import { MutationFunction } from "@tanstack/react-query";

import { api } from "#app/http/api";
import { Contact, ContactDto } from "#modules/contacts/infra/Contact.dto";

export const updateContact: MutationFunction<
  ContactDto | null,
  { id: string; contact: Partial<Contact> }
> = async ({ id, contact }) => {
  const payload = {
    ...contact,
  };

  const response = await api.contacts.update.mutation({
    body: payload,
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
